export const texts = {
  de: {
    mobileAnlageprodukteKapitalschutz: 'Anlageprodukte mit Kapitalschutz',
    mobileAnlageprodukteOhneKapitalschutz: 'Anlageprodukte ohne Kapitalschutz',
    mobileHebelprodukte: 'Hebelprodukte'
  },
  en: {
    mobileAnlageprodukteKapitalschutz:
      'Investment Products with 100 % Capital Protection',
    mobileAnlageprodukteOhneKapitalschutz:
      'Investment Products without Capital Protection',
    mobileHebelprodukte: 'Leverage Products'
  }
}

export const categoryInfoContentDict = {
  de: {
    'zinsanleihen-section': (
      <>
        Festzins- und
        <br />
        Stufenzins-
        <br />
        Anleihen
      </>
    ),
    'strukturierte-anleihen-section': (
      <>
        Strukturierte
        <br />
        Anleihen
      </>
    ),
    'kapitalschutz-section': (
      <>
        Kapitalschutz-
        <br />
        Zertifikate
      </>
    ),
    'schuldverschreibung-section': (
      <>
        Bonitäts-
        <br />
        abhängige
        <br />
        Schuldverschrei-
        <br />
        bungen
      </>
    ),
    'express-section': (
      <>
        Express-
        <br />
        Zertifikate
      </>
    ),
    'aktienanleihen-section': <>Aktienanleihen</>,
    'discount-section': (
      <>
        Discount-
        <br />
        Zertifikate
      </>
    ),
    'bonus-section': (
      <>
        Bonus-
        <br />
        Zertifikate
      </>
    ),
    'index-section': (
      <>
        Index- und
        <br />
        Partizipations-
        <br />
        Zertifikate
      </>
    ),
    'option-section': <>Optionsscheine</>,
    'faktor-section': (
      <>
        Faktor-
        <br />
        Optionsscheine
      </>
    ),
    'knock-out-section': (
      <>
        Knock-out-
        <br />
        Optionsscheine
      </>
    )
  },
  en: {
    'zinsanleihen-section': (
      <>
        Fixed-Rate and
        <br />
        Step-Up
        <br />
        Bonds
      </>
    ),
    'strukturierte-anleihen-section': (
      <>
        Capital
        <br />
        Protection
        <br />
        Products with
        <br />
        Coupon
      </>
    ),
    'kapitalschutz-section': (
      <>
        Uncapped
        <br />
        Capital
        <br />
        Protection
        <br />
        Products
      </>
    ),
    'schuldverschreibung-section': (
      <>
        Credit-Linked
        <br />
        Notes
      </>
    ),
    'express-section': (
      <>
        Express
        <br />
        Certificates
      </>
    ),
    'aktienanleihen-section': (
      <>
        Reverse
        <br />
        Convertibles
      </>
    ),
    'discount-section': (
      <>
        Discount
        <br />
        Certificates
      </>
    ),
    'bonus-section': (
      <>
        Bonus
        <br />
        Certificates
      </>
    ),
    'index-section': (
      <>
        Tracker
        <br />
        Certificates
      </>
    ),
    'option-section': <>Warrants</>,
    'faktor-section': (
      <>
        Constant
        <br />
        Leverage
        <br />
        Warrants
      </>
    ),
    'knock-out-section': (
      <>
        Knock-Out
        <br />
        Warrants
      </>
    )
  }
}

export const categoryInfoColorDict = {
  'zinsanleihen-section': 'rgb(32.156372%,47.058105%,63.922119%)',
  'strukturierte-anleihen-section': 'rgb(32.156372%,47.058105%,63.922119%)',
  'kapitalschutz-section': 'rgb(32.156372%,47.058105%,63.922119%)',
  'schuldverschreibung-section': 'rgb(0%,52.941895%,49.01886%)',
  'express-section': 'rgb(0%,52.941895%,49.01886%)',
  'aktienanleihen-section': 'rgb(0%,52.941895%,49.01886%)',
  'discount-section': 'rgb(0%,52.941895%,49.01886%)',
  'bonus-section': 'rgb(0%,52.941895%,49.01886%)',
  'index-section': 'rgb(0%,52.941895%,49.01886%)',
  'option-section': 'rgb(41.175842%,25.097656%,39.99939%)',
  'faktor-section': 'rgb(41.175842%,25.097656%,39.99939%)',
  'knock-out-section': 'rgb(41.175842%,25.097656%,39.99939%)'
}

export const capitalProtect = [
  'zinsanleihen-section',
  'strukturierte-anleihen-section',
  'kapitalschutz-section'
]
export const investProductsWithoutCP = [
  'schuldverschreibung-section',
  'express-section',
  'aktienanleihen-section',
  'discount-section',
  'bonus-section',
  'index-section'
]
export const leverageProducts = [
  'option-section',
  'faktor-section',
  'knock-out-section'
]

export const checkCategoriesDict = {
  'check-0': [
    'zinsanleihen-section',
    'strukturierte-anleihen-section',
    'kapitalschutz-section'
  ],
  'check-1': [
    'express-section',
    'aktienanleihen-section',
    'discount-section',
    'bonus-section'
  ],
  'check-2': [
    'zinsanleihen-section',
    'strukturierte-anleihen-section',
    'schuldverschreibung-section',
    'express-section',
    'aktienanleihen-section'
  ],
  'check-3': [
    'kapitalschutz-section',
    'express-section',
    'discount-section',
    'aktienanleihen-section',
    'bonus-section',
    'index-section'
  ],
  'check-4': [
    'express-section',
    'discount-section',
    'aktienanleihen-section',
    'bonus-section'
  ],
  'check-5': [
    'express-section',
    'discount-section',
    'aktienanleihen-section',
    'bonus-section'
  ],
  'check-6': ['option-section', 'faktor-section', 'knock-out-section'],
  'check-7': ['zinsanleihen-section', 'strukturierte-anleihen-section'],
  'check-8': [
    'kapitalschutz-section',
    'express-section',
    'discount-section',
    'aktienanleihen-section',
    'bonus-section'
  ],
  'check-9': ['option-section']
}
